import { render, staticRenderFns } from "./InsUserPopGallery.vue?vue&type=template&id=5e4d817a&scoped=true&"
import script from "./InsUserPopGallery.vue?vue&type=script&lang=ts&"
export * from "./InsUserPopGallery.vue?vue&type=script&lang=ts&"
import style0 from "./InsUserPopGallery.scss?vue&type=style&index=0&id=5e4d817a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d817a",
  null
  
)

export default component.exports